import { searchActions } from '@sv-support-sdk/store';

export const searchResultsByValue = searchActions.searchResultsByValue;
